module.exports = __webpack_public_path__ + "static/media/IconClock-Active.ac4d2c51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconClock-Active.svg
// module id = 948
// module chunks = 0